import { createFormData } from 'infra/helpers/createFormData';
import { useMutation } from "react-query";
import http from "infra/http";
import { DocumentoForm, UseSaveDocumentosProps } from 'core/features/documentos/typings';

function useSaveDocumentoUnidade({id, unidadeId}: UseSaveDocumentosProps) {
  return useMutation(
    (data: DocumentoForm) => {
      if (id) {
        return http.put(`/v1/documento/${id}`, data);
      }

      const formData = createFormData(data.file, data, 'file');

      return http.post(`/v1/unidade/${unidadeId}/documento`, formData);
    },
    { retry: false }
  );
}

export default useSaveDocumentoUnidade;
